import type { City } from 'src/types/__generated__/graphql';

export const formatCityNameAndZipCode = (city: Pick<City, 'name' | 'zipCodes'>) => {
    if (!city.zipCodes?.[0]) {
        return city.name;
    }
    return `${city.name}, ${city.zipCodes[0]}`;
};
